export const FEATURES = [
  {
    name: 'Transaction fee',
    value: ['10%', '0%', '0%', '0%'],
    // promo: ['0%', '0%', '0%', '0%'],
    tooltip:
      'In addition, on all plans\nthere is a credit card processing\nfee charged by Stripe,\nof 2.9%+$0.3 per transaction.',
  },
  {
    name: 'Number of soundcasts',
    value: ['Unlimited', 'Unlimited', 'Unlimited', 'Unlimited'],
    tooltip: 'A soundcast = an audiobook,\na course, a podcast, or an album.',
  },
  {
    name: 'Number of listeners',
    value: ['Unlimited', 'Unlimited', 'Unlimited', 'Unlimited'],
    tooltip: 'People who can register\nfor your public soundcasts\nthat are either free or paid',
  },
  {
    name: 'White label mobile apps',
    value: ['', '', '', true],
    tooltip: 'Your own native apps\non both iOS and Android.',
  },
  {
    name: 'In-app purchases',
    value: ['', '', '', true],
    tooltip: 
      'This optional add-on allows listeners to buy audio directly\n' +
      'from your white-label app with in-app purchase.\n' +
      'Add-on cost: $100/month.',
  },
  {
    name: 'Remove soundwise branding',
    value: ['', '', '', true],
    tooltip: 'Remove our logo\nfrom your public pages.',
  },
  {
    name: 'Listener names & emails',
    value: [true, true, true, true],
    tooltip: 'Email address of everyone\nwho signed up for your audio.',
  },
  {
    name: 'Listen from mobile app & web',
    value: [true, true, true, true],
    tooltip: 'Convenient and safe\nfor your paid content.',
  },
  {
    name: 'Promo codes',
    value: ['Unlimited', 'Unlimited', 'Unlimited', 'Unlimited'],
    tooltip: 'Offer discounts or\nlimited-time promotions.',
  },
  {
    name: 'Sell subscriptions',
    value: [true, true, true, true],
    tooltip: 'Option to earn recurring\nrevenues besides one-time sales.',
  },
  {
    name: 'Trial access',
    value: [true, true, true, true],
    tooltip: 'Offer free trials on your\nsubscription audio.',
  },
  {
    name: 'Sell rentals',
    value: [true, true, true, true],
    tooltip: 'Charge for limited-time access.',
  },
  {
    name: 'Sell bundles',
    value: [true, true, true, true],
    tooltip:
      'Bundling your soundcasts\ntogether for promotion and\nfor selling subscription library.',
  },
  {
    name: 'Companion material',
    value: [true, true, true, true],
    tooltip: 'Add a companion PDF\nor image to an audio track.',
  },
  {
    name: 'Manual listener import',
    value: [true, true, true, true],
    tooltip: 'Give listeners access\nby email address.',
  },
  {
    name: 'Listener community',
    value: [true, true, true, true],
    tooltip: 'Listeners can like and comment\non your audio and interact\nwith each other.',
  },
  {
    name: 'Private soundcasts',
    value: ['50 listeners', '200 listeners', 'Unlimited', 'Unlimited'],
    tooltip: 'Unlisted & unsearchable\nsoundcasts for private\nmemberships and internal audience.',
  },
  {
    name: 'Number of admins',
    value: [1, 2, 5, 'Unlimited'],
    tooltip: 'Admins have access to your user\ndashboard.',
  },
  {
    name: 'Podcast feeds',
    value: [1, 5, 'Unlimited', 'Unlimited'],
    tooltip: 'RSS feeds for free podcasts.',
  },
  {
    name: 'TubeToPod',
    value: ['', '1 Channel', 'Unlimited', 'Unlimited'],
    tooltip: 'Convert a Youtube channel\ninto a soundcast.',
  },
  {
    name: 'Content scheduling',
    value: ['', true, true, true],
    tooltip: 'Schedule audio tracks\nto be published later.',
  },
  {
    name: 'Content dripping',
    value: ['', true, true, true],
    tooltip: 'Time release audio tracks\nto listeners according to\nwhen they signed up.',
  },
  {
    name: 'Mailchimp integration',
    value: ['', true, true, true],
    tooltip: 'Export your listener\nemail list to Mailchimp.',
  },
  {
    name: 'Recording from dashboard',
    value: ['', true, true, true],
    tooltip: 'In-browser audio recording.',
  },
  {
    name: 'Listening analytics',
    value: ['', true, true, true],
    tooltip: 'Listening record\ndown to each listener.',
  },
  {
    name: 'Soundwave videos',
    value: ['', true, true, true],
    tooltip: 'Convert audio into video\n(1 hr max per video).',
  },
  {
    name: 'Audio processing',
    value: ['', true, true, true],
    tooltip: 'Add intro/outro clips,\nadjust volume,\nremove silence.',
  },
  {
    name: 'In-app messages to listeners',
    value: ['', true, true, true],
    tooltip: 'Group messages to listeners\nvia our mobile app.',
  },
  {
    name: 'Email to listeners',
    value: ['', true, true, true],
    tooltip: 'Send bulk email\nnotifications to listeners.',
  },
  {
    name: 'Non-payment access link',
    value: ['', true, true, true],
    tooltip: 'Give listeners access\nbypassing the paywall.',
  },
  {
    name: 'Multiple pricing options',
    value: ['', '', true, true],
    tooltip:
      'Give listeners choices of\ndifferent purchase options,\n' +
      'e.g. one-time buy, subscriptions of\n' +
      'different intervals, etc.',
  },
  {
    name: 'API access',
    value: ['', '', true, true],
    tooltip: 'Subscribe and unsubscribe listeners\nvia Soundwise’s Partner API.',
  },
  {
    name: 'Zapier integration',
    value: ['', '', true, true],
    tooltip: 'Connect to 1500+ other apps\nto simplify workflow.',
  },
  {
    name: 'Bandwidth',
    value: ['150 GB per month', '150 GB per month', '150 GB per month', 'Unlimited'],
    tooltip: 
      'Total bandwidth of downloads.\n' +
      'Additional bandwidth usage will incur\n' +
      'a surcharge of $2 per 10 GB on Plus and Pro plans.',
  },
];
